import React from 'react';
import PropTypes from 'prop-types';
import Label from 'components/Label';
import styles from './index.module.scss';
import startCase from 'lodash/startCase';
import cn from 'classnames';
import { capitalize } from '@material-ui/core';
import { images } from '../../../utils/icons';

const ServiceInfo = ({ value }) => {
  return (
    <div className={styles.serviceContainer}>
      {Array.isArray(value)
        ? value.map((service, key) => (
            <div key={key} className={styles.serviceRow}>
              <Label label={service.header} className={styles.serviceLabel} />
              <div
                key={key}
                className={cn(
                  styles.serviceList,
                  styles[
                    `justifyContent${capitalize(service.justifyContent || '')}`
                  ],
                  styles[`gap${capitalize(service.gap || '')}`],
                )}
              >
                {Array.isArray(service.data)
                  ? service.data.map((serviceData, key) => (
                      <Label
                        icon={
                          serviceData?.icon
                            ? serviceData.icon
                            : images[serviceData.id]
                        }
                        label={startCase(serviceData.name)}
                        key={key}
                      />
                    ))
                  : service.data}
              </div>
            </div>
          ))
        : value}
    </div>
  );
};

ServiceInfo.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default ServiceInfo;
